import {
  SET_SELECTED_SHIFT,
  SET_SHIFTS,
  SET_SHIFTS_LOADED,
  SET_SHIFT_FILTER,
  ShiftAction,
  ShiftState,
} from '../types'

const initialState: ShiftState = {
  shifts: [],
  isShiftsLoaded: false,
  shiftFilter: {
    name: '',
    stationName: '',
  },
}

export const shiftReducer = (
  state = initialState,
  action: ShiftAction
): ShiftState => {
  switch (action.type) {
    case SET_SHIFTS:
      return {
        ...state,
        shifts: action.payload,
      }
    case SET_SHIFTS_LOADED:
      return {
        ...state,
        isShiftsLoaded: action.payload,
      }
    case SET_SELECTED_SHIFT:
      return {
        ...state,
        selectedShift: action.payload,
      }
    case SET_SHIFT_FILTER:
      return {
        ...state,
        shiftFilter: action.payload,
      }
    default:
      return state
  }
}
